import { minLength, maxLength, stringPattern, tagMaxLength, tagMinLength } from '../../utils/form-validations';

export const addUseCaseDefaultFields = {
  use_case_name: '',
  no_of_egs: 0,
  configured_egs: 0,
  not_configured_egs: 0,
  deployed_egs: 0,
  onto_manage_id: null,
};

// Use Case
export const useCaseUISchema = [
  { id: 1, label: 'Name of Use Case', name: 'use_case_name', type: 'input', required: true },
  { id: 2, label: 'Country', name: 'onto_manage_id', type: 'select', required: true },
];

export const useCaseSchema = {
  type: 'object',
  properties: {
    onto_manage_id: { type: 'number', minLength: 1, maxLength },
    use_case_name: { type: 'string', minLength, maxLength, pattern: stringPattern },
  },
  required: ['onto_manage_id', 'use_case_name'],
  additionalProperties: true,
};

export const useCaseMetaDataSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
    value: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
  },
  required: ['key', 'value'],
};
